/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_SelectedInputs */

const en_mobile_selected = /** @type {(inputs: Mobile_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selected`)
};

const es_mobile_selected = /** @type {(inputs: Mobile_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionada`)
};

/**
* | output |
* | --- |
* | "Selected" |
*
* @param {Mobile_SelectedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_selected = /** @type {((inputs?: Mobile_SelectedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_SelectedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_selected(inputs)
	return en_mobile_selected(inputs)
});